module.exports = "./static/login-bg.2ba3199c.png";